<template>
    <vx-card no-shadow>

        <!-- Img Row -->
        <div class="flex flex-wrap items-center mb-base">
            <vs-avatar :src="fileUrl ? fileUrl : activeUserInfo.avatar + '?' + Math.random()" size="70px" class="mr-4 mb-4" />
            <div>
                <vs-button @click="$refs.fileInput.click()" v-if="files.length === 0">Upload photo</vs-button>
                <vs-button @click="removeFiles()" class="mr-4 sm:mb-0 mb-2" type="border" color="danger" v-if="files.length > 0">Remove</vs-button>
                <input ref="fileInput" type="file" style="display: none" @change="onChangeFile">
                <vs-button v-if="files.length > 0" class="ml-auto mt-2" @click="saveChange()">Save Changes</vs-button>
                <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p>
            </div>
        </div>
    </vx-card>
</template>


<script>
    import user from "@/api/user.js";

    export default {
        data() {
            return {
                files: [],
                fileUrl: null
            }
        },
        computed: {
            activeUserInfo() {
                return this.$store.state.AppActiveUser
            }
        },

        methods: {
            onChangeFile(e) {
                this.files = e.target.files;
                this.fileUrl = URL.createObjectURL(this.files[0]);
            },
            removeFiles() {
                this.files = [];
                this.fileUrl = null;
            },
            saveChange() {
                const formData = new FormData();
                formData.append("file", this.files[0]);

                user.uploadPhoto(formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    if (response.data.status) {
                        this.$vs.notify({
                            title: "Info",
                            time: 3000,
                            text:
                                "Photo berhasil di upload",
                            color: "success",
                            position: "top-right"
                        });
                        this.removeFiles();
                    } else {
                        this.$vs.notify({
                            title:
                                "Terjadi Kesalahan",
                            time: 3000,
                            text: response.data.message,
                            color: "danger",
                            position: "top-right"
                        });
                    }
                });
            },
        }
    }
</script>